import { Modal } from "react-bootstrap";
import { useCallback, useEffect, useRef } from "react";
import { ModalInformationContentStyled, ModalInformationStyled, ModalWrapperStyled } from "./styled/ModalsStyled";
import PromocodeHelloJetvix from "../Bonus/components/BonusDoubleDeposit/PromocodeHelloJetvix";
import { MODALS_NAME } from "./modalsConstants";
import { useDispatch } from "react-redux";
import { logAppsflyerAction, openModalAction } from "../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../app/appConstants";

function PromocoeHelloJetvixModal() {
    const dispatch = useDispatch();
    const isSendBackButtonEventRef = useRef(true);

    useEffect(() => {
        return () => {
            if (isSendBackButtonEventRef.current) {
                dispatch(logAppsflyerAction({
                    name: LOG_AF_EVENT_NAMES.CASHIER_PROMOCODE_MODAL,
                    payload: { button: 'back' },
                }));
            }
        }
    }, [dispatch]);

    const onTopUpClickHandler = useCallback(() => {
        isSendBackButtonEventRef.current = false;
        dispatch(openModalAction({ name: MODALS_NAME.CASHIER, tab: 'deposit' }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.CASHIER_PROMOCODE_MODAL,
            payload: { button: 'top_up' }
        }));
    }, [dispatch]);

    const onCloseClickHandler = useCallback(() => {
        isSendBackButtonEventRef.current = false;
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.CASHIER_PROMOCODE_MODAL,
            payload: { button: 'cross_button' }
        }));
    }, [dispatch]);

    return <ModalInformationStyled>
        <Modal.Header closeButton onClick={onCloseClickHandler}/>
        <ModalWrapperStyled>
            <ModalInformationContentStyled>
                <PromocodeHelloJetvix onTopUpClick={onTopUpClickHandler}/>
            </ModalInformationContentStyled>
        </ModalWrapperStyled>
    </ModalInformationStyled>
}

export default PromocoeHelloJetvixModal;
